<template>
  <a class="relative cursor-default w-full h-[51px] border-b no-default-style
            border-zt-light bg-[#3A4B6459] flex items-center gap-2 pl-2 py-1.5 xl:pr-1"
     :class="{'hover:bg-zt-light/50 cursor-pointer' : match.localteam_team_query_name && match.visitorteam_team_query_name}"
     :href="match?.localteam_team_query_name && match?.visitorteam_team_query_name ? `/wyniki-pilka-nozna/porownanie-druzyn/${match.localteam_team_query_name}/${match.visitorteam_team_query_name}/` : null">
    <div class="text-zt-more text-center text-xs w-[46px] shrink-0 h-full flex flex-col justify-center
                          items-center font-['Lato']">
      <template v-if="match.date !== '2023-09-28 21:00:00'">
        <span>{{ match.date.split()[0] }}</span>
        <span>{{ match.date.split()[1] }}</span>
      </template>
      <span v-else>-</span>
    </div>
    <div class="flex flex-col w-full gap-y-[2px]">
      <div class="text-xs text-dark flex items-center">
        <template v-if="match?.top_team?.length > 0 || match?.localteam_name.length > 0">
                    <span class="inline-block aspect-square h-3.5 overflow-hidden">
                      <img :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${match?.localteam_team_query_name}.png`"
                           width="17" height="17" :alt="match?.top_team"/>
                    </span>
          <span class="ml-2 font-normal line-clamp-1">
                      <span>{{ match?.localteam_name.length > 0 ? match?.localteam_name : match.top_team }}</span>
                    </span>
        </template>
        <template v-else>
                    <span class="inline-block aspect-square h-3.5 overflow-hidden">
                    <img ref="localTeamImg" class="w-[14px] h-[14px] object-contain mx-auto"
                         :src="`/wp-content/themes/zawodtyper/assets/images/staty_football/${Object.hasOwn(match, 'localteam_id') ? 'teamfallback' : 'countryfallback'}.svg`"
                         alt="''"/>
                    </span>
          <span class="ml-2 font-normal line-clamp-1">
                      <span>{{ match.top_text }}</span>
                    </span>
        </template>
      </div>
      <div class="text-xs text-dark flex items-center">
        <template v-if="match?.bottom_team?.length > 0 || match?.visitorteam_name.length > 0">
                    <span class="inline-block aspect-square h-3.5 overflow-hidden">
                      <img :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${match?.visitorteam_team_query_name}.png`"
                           width="17" height="17" :alt="match?.bottom_team"/>
                    </span>
          <span class="ml-2 font-normal line-clamp-1">
                      <span>{{ match?.visitorteam_name.length > 0 ? match?.visitorteam_name : match.bottom_team }}</span>
                    </span>
        </template>
        <template v-else>
                    <span class="inline-block aspect-square h-3.5 overflow-hidden">
                    <img ref="localTeamImg" class="w-[14px] h-[14px] object-contain mx-auto"
                         :src="`/wp-content/themes/zawodtyper/assets/images/staty_football/${Object.hasOwn(match, 'visitorteam_id') ? 'teamfallback' : 'countryfallback'}.svg`"
                         alt="''"/>
                    </span>
          <span class="ml-2 font-normal line-clamp-1">
                      <span>{{ match.bottom_text }}</span>
                    </span>
        </template>
      </div>
    </div>
    <div class="text-xs text-right min-w-5 flex shrink-0 flex-col gap-y-[5px] ml-auto font-['Lato']  font-bold">
      <div class="w-4 relative !opacity-90 text-center">-</div>
      <div class="w-4 relative !opacity-90 text-center">-</div>
    </div>
    <span v-if="match.localteam_team_query_name && match.visitorteam_team_query_name"
          class="cursor-pointer no-default-style pl-px pr-[9px]">
                <svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="25" height="19" rx="3" fill="#B3B3B3" fill-opacity="0.75"/>
                  <path d="M7.58527 7.36C8.13194 7.36 8.56194 7.51667 8.87527 7.83C9.19527 8.14333 9.35527 8.58 9.35527 9.14C9.35527 9.32667 9.33527 9.52667 9.29527 9.74L8.71527 13H7.01527L7.55527 9.97C7.57527 9.85667 7.58527 9.75667 7.58527 9.67C7.58527 9.39 7.50527 9.17333 7.34527 9.02C7.19194 8.86667 6.97527 8.79 6.69527 8.79C6.36194 8.79 6.08194 8.89333 5.85527 9.1C5.62861 9.30667 5.48194 9.59667 5.41527 9.97V9.95L4.87527 13H3.16527L4.47527 5.6H6.18527L5.73527 8.16C5.95527 7.91333 6.22527 7.72 6.54527 7.58C6.86527 7.43333 7.21194 7.36 7.58527 7.36ZM10.1536 11.35C10.8802 10.83 11.4602 10.4 11.8936 10.06C12.3269 9.72 12.7002 9.37333 13.0136 9.02C13.3336 8.66 13.5202 8.31667 13.5736 7.99C13.5936 7.89667 13.6036 7.81 13.6036 7.73C13.6036 7.53667 13.5502 7.39 13.4436 7.29C13.3436 7.19 13.1902 7.14 12.9836 7.14C12.4702 7.14 12.1436 7.50333 12.0036 8.23H10.3436C10.5169 7.39 10.8769 6.76 11.4236 6.34C11.9769 5.91333 12.6102 5.7 13.3236 5.7C14.0169 5.7 14.5302 5.85667 14.8636 6.17C15.2036 6.48333 15.3736 6.89667 15.3736 7.41C15.3736 7.57 15.3602 7.71667 15.3336 7.85C15.2136 8.53 14.8602 9.16333 14.2736 9.75C13.6936 10.3367 12.9736 10.9233 12.1136 11.51H14.8136L14.5636 12.9H9.54355L9.76355 11.63L10.1536 11.35ZM19.7364 7.36C20.2831 7.36 20.7131 7.51667 21.0264 7.83C21.3464 8.14333 21.5064 8.58 21.5064 9.14C21.5064 9.32667 21.4864 9.52667 21.4464 9.74L20.8664 13H19.1664L19.7064 9.97C19.7264 9.85667 19.7364 9.75667 19.7364 9.67C19.7364 9.39 19.6564 9.17333 19.4964 9.02C19.3431 8.86667 19.1264 8.79 18.8464 8.79C18.5131 8.79 18.2331 8.89333 18.0064 9.1C17.7798 9.30667 17.6331 9.59667 17.5664 9.97V9.95L17.0264 13H15.3164L16.6264 5.6H18.3364L17.8864 8.16C18.1064 7.91333 18.3764 7.72 18.6964 7.58C19.0164 7.43333 19.3631 7.36 19.7364 7.36Z" fill="#3A4B64"/>
                </svg>
              </span>
    <div v-else class="w-11"></div>
  </a>
</template>

<script>
export default {
  name: 'MatchPlaceholder',
  props: ['match'],
};
</script>